const TYPES = ({
  clearResult: 'CLEAR_ARTICLE_DETAILS',
  detailsData: 'GET_ARTICLE_DETAILS',
  detailsError: 'GET_ARTICLE_DETAILS_ERROR',
})

export default TYPES;
